define(function() {
    var instance = null;

    function MySingleton() {
        if (instance !== null) {
            throw new Error("Cannot instantiate more than one MySingleton, use MySingleton.getInstance()");
        }

        this.initialize();
    }

    MySingleton.prototype = {
        initialize: function() {
            // summary:
            // Initializes the singleton.
            this.mApp = null;
            this.userInfo = null;
            this.token = null;
            this.instanceId = null;
            this.companyId = null;
            this.instanceName = null;
            this.epigraphs = [];
            this.areas = [];
            this.mainMenu = null;
            this.enviroMenu = null;
            this.downloadPending = null;
            this.report = null;
        }
    };

    MySingleton.getInstance = function() {
        // summary:
        //      Gets an instance of the singleton. It is better to use
        if (instance === null) {
            instance = new MySingleton();
        }
        return instance;
    };

    return MySingleton.getInstance();
});


//////////////////
// WEBPACK FOOTER
// ./app/session/session.js
// module id = 4
// module chunks = 0